<template>
  <div class="product-detail-wrapper">
    <div v-if="breadcrumbs.length" class="breadcrumbs-div">
      <breadcrumbs-categories
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs-categories"
      />
    </div>
    <div class="content-container pt-20 pb-50">
      <b-loading :active.sync="isLoading" :can-cancel="false" />

      <message-area />

      <div v-if="product" class="tile is-ancestor mt-20">
        <div class="product-gallery tile is-vertical is-parent is-5">
          <div class="product-gallery-inner tile is-child">
            <div class="product-image item_img_lg">
              <img
                v-if="isProductSold"
                :src="require('@/assets/images/icons/sold-mark-large.png')"
                class="badge-image"
              />
              <img :src="largeImage" alt="..." class="img-thumbnail" />
            </div>
            <div class="columns is-multiline is-mobile is-variable is-4 mt-30">
              <div
                v-for="img in product.image"
                :key="img"
                class="column is-4-mobile is-4-tablet is-3-desktop"
              >
                <div class="item_img_sm" @click="image_selected = img">
                  <img
                    :src="img"
                    alt="..."
                    class="img-thumbnail cursor_pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child">
            <div class="columns is-multiline is-mobile is-variable is-6">
              <div class="column is-12-mobile is-12-tablet is-7-desktop">
                <div
                  :key="rdKey"
                  class="tile is-child"
                  style="margin-bottom: 20px !important;"
                >
                  <router-link
                    :to="`/customer/shop/${product.owner}`"
                    class="cursor_pointer"
                    >{{ product.shopName }}
                  </router-link>
                  <br />
                  <h5 class="c-text_title word-break">{{ product.name }}</h5>
                  <div>
                    <span style="font-size: 24px" class="text-bold"
                      >{{ product.price }} {{ $t('common.currency') }}</span
                    >
                  </div>

                  <div class="tile is-vertical">
                    <b-radio
                      v-for="(property, index) in properties"
                      :key="index"
                      :value="currentPropertyIndex"
                      :native-value="index"
                      class="mt-15 no-margin-left"
                      @input="changeProperty(index)"
                    >
                      {{ property.title }}
                    </b-radio>
                  </div>

                  <span class="mr-10">数量</span>
                  <integer-plusminus
                    :min="quantityMin"
                    :max="quantityMax"
                    v-model="cartAmount"
                    class="mt-15"
                  >
                    {{ cartAmount }}
                    <template slot="decrement"
                      >−</template
                    >
                    <template slot="increment"
                      >+</template
                    >
                  </integer-plusminus>
                </div>

                <div class="my-20">
                  <span class="text-bold">発送の目安：{{ ' ' + shippingDate }}</span>
                </div>

                <nav class="level product-detail">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <div
                           @click="addProductToCart">
                        <a :class="{'added-to-cart': isProductSold}"
                          class="button add-to-cart is-primary btn-detail" type="primary">
                          <span class="icon icon-cart">
                            <!--eslint-disable-next-line--><!--prettier-ignore-->
                            <img :src="require('@/assets/images/icons/icon-cart-white.png')"
                              class="right-icon"
                            />
                          </span>
                          <span>{{ $t('C021_17') }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- Right side -->
                  <div class="level-right">
                    <div class="level-item">
                      <a
                        :class="{ 'added-to-wishlist': is_rating }"
                        class="button add-to-wishlist"
                        @click="productInFavourite"
                      >
                        <span
                          ><i class="far fa-heart mr-10" />{{
                            is_rating
                              ? 'マイリストから削除'
                              : 'マイリストに追加'
                          }}</span
                        >
                      </a>
                    </div>
                  </div>
                </nav>
                <div class="recommend-actions">
                  <a :class="{'disabled': isRecommended}" class="btn-recommend" @click="confirmRecommend"></a>
                  <router-link :to="{ name: 'RecommendGuide', query: { return_link: $route.path } }" class="help-link">おすすめとは？</router-link>
                </div>
                <div v-if="isRecommended" class="social-sharing mt-15">
                  <SocialSharing
                    :icon="require('@/assets/images/icons/icon-twitter.svg')"
                    :url="recommendLink"
                    :content="`${product.name}はオススメです！`"
                    hashtags="reptop"
                    type="twitter"
                  />
                  <SocialSharing
                    :icon="require('@/assets/images/icons/icon-facebook.svg')"
                    :url="recommendLink"
                    :content="`${product.name}はオススメです！`"
                    hashtags="reptop"
                    type="facebook"
                  />
                </div>
              </div>
              <div class="column is-12-mobile is-12-tablet is-5-desktop">
                <shop-basic-info
                  :shop="shop"
                  :shop-reviews="shopReviews"
                  :product="product"
                />
              </div>
            </div>

            <div class="desc_item_detail">
              <h5 class="c-text_title mt-30">商品詳細</h5>
              <div class="word-break">{{ product.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="product" class="tile is-ancestor hr my-55"></div>
      <div v-if="product" class="tile is-ancestor mt-20">
        <div class="tile is-parent container-inner">
          <ProductReviews :id="product.id" :has-filter="false" :has-rating-statistic="true" heading="ユーザーレビュー" pagination-type="link"/>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRecommendShowActive" has-modal-card>
      <RecommendPopup
        :item="{
          title: '現在使用しているおすすめ枠',
          content: recommendPopupContent
        }"
        :confirmed="!canRecommend"
        :confirm="() => addRecommend()"
        title="おすすめに追加しますか？"
      />
    </b-modal>
  </div>
</template>

<style lang="scss" src="./product-detail.scss">
</style>

<script>
import config from '@/config';
import { getDataCarts, addToCart, removeProductInCart } from '@/services/cart.service';
import { Loading } from '@/services/loading';
import * as userService from '@/services/user.service';
import { getUserProfile } from '@/services/profile.service';
import { status_response } from '@/services/constants';
import { getProductDetail, getProductStockById } from '@/services/product.service';
import { getShopInfo, getStatisticReview } from '@/services/shop.service';
import {
  checkProductInRecommendList,
  addProductRecommend,
  getOverview,
  setStorageAffiliator
} from '@/services/affiliate.service';
import BreadcrumbsCategories from '@/components/breadcrumbs/breadcrumbs-categories';
import { AddOrRemoveToFavouriteList, checkProductInFavouriteList } from '@/services/userFavourire.service';
import ShopBasicInfo from '../shop/shop-basic-info';
import ProductReviews from '@/views/customer/reviews/product/list/list.vue';
import MessageArea from '@/components/common/message-area/message-area.vue';
import messageUtils from '@/utils/mixins/messageUtils';
import RecommendPopup from '@/components/common/confirm-popup/recommend-popup.vue';
import SocialSharing from '@/components/SocialSharing.vue';
import { getIndexOfProperty, getProductProperties, getProductQuantity } from '@/services/properties.service';
import { IntegerPlusminus } from 'vue-integer-plusminus';

export default {
  name: 'ProductDetail',
  components: {
    MessageArea,
    BreadcrumbsCategories,
    ShopBasicInfo,
    ProductReviews,
    IntegerPlusminus,
    RecommendPopup,
    SocialSharing
  },
  mixins: [messageUtils],
  data() {
    return {
      product: null,
      cartAmount: 0,
      image_selected: '',
      is_rating: false,
      checkRadio: 1,
      rdKey: 0, //For prevent default radio click
      isProductInCart: false,
      isProductSold: false,
      currentProperty: null,
      properties: [],
      // currentPropertyIndex: null,
      shop: {
        name: '',
        numOfReview: 1,
        totalPointReview: 0,
        image: [],
        description: []
      },
      per_page: 1,
      breadcrumbs: [],
      id: '',
      per_page_bottom: 10,
      cartData: [],
      shopReviews: {
        oneStar: 0,
        twoStar: 0,
        threeStar: 0,
        fourStar: 0,
        fiveStar: 0
      },
      profileUser: null,
      recommend: null,
      affiliator: null,
      recommendUsed: null,
      recommendTotal: null,
      isRecommended: false,
      isRecommendShowActive: false
    };
  },
  computed: {
    currentPropertyIndex: function() {
      return getIndexOfProperty(this.product, this.currentProperty);
    },
    largeImage() {
      if (this.image_selected) {
        return this.image_selected;
      }

      if (this.product && this.product.image && this.product.image.length > 0) {
        return this.product.image[0];
      }

      return require('@/assets/images/goods_default.svg');
    },
    recommendLink() {
      const url = `${document.location.protocol}//${document.location.host}${this.$route.path}`;

      if (this.product && this.isRecommended && this.profileUser && this.profileUser.publicAddress) {
        return `${config.FIREBASE_SERVER_URL}/elasticsearch/s/${this.product.id}?redirect=${url}?affiliator=${
          this.profileUser.publicAddress
        }`;
      }

      return url;
    },
    canRecommend() {
      return this.recommendUsed !== null && this.recommendTotal !== null && this.recommendUsed < this.recommendTotal;
    },
    recommendPopupContent() {
      return this.recommendUsed !== null && this.recommendTotal !== null
        ? `${this.recommendUsed}/${this.recommendTotal}`
        : '0/0';
    },
    shippingDate() {
      let result = '';
      const shippingDate = this.$t('shippingDate');
      switch (this.product.detail.shipping_date) {
        case '1':
          result = shippingDate[0].dates;
          break;
        case '2':
          result = shippingDate[1].dates;
          break;
        case '3':
          result = shippingDate[2].dates;
          break;
        default:
          break;
      }
      return result;
    },
    quantityMax() {
      return this.product ? this.product.properties.stock_num : 1;
    },
    quantityMin() {
      return this.quantityMax !== 0 ? 1 : 0;
    }
  },
  watch: {
    cartData: function(cartData) {
      const productId = parseInt(this.id);
      this.isProductInCart = false;
      for (let i = 0; i < cartData.length; i++) {
        if (parseInt(cartData[i].productId) === productId) {
          this.isProductInCart = true;
          this.currentProperty = this.cartData[i].propId;
          break;
        }
      }
    },
    quantityMax: function(value) {
      if (value === 0) this.cartAmount = 0;
    }
  },
  created() {
    this.id = parseInt(this.$route.params.id);
    this.affiliator = this.$route.query && this.$route.query.affiliator ? this.$route.query.affiliator : null;
    setStorageAffiliator(this.id, this.affiliator);
    parent.scrollTo(0, 0);
  },
  async mounted() {
    await this.getCurrentUser();
    await this.getProductDetailById();
    this.getCartData();
    this.checkProductInFavouriteList();
    this.getOverview();
    this.fetchUserProfile();
  },
  methods: {
    async getCurrentUser() {
      try {
        this.user = await userService.getCurrentUser();
      } catch (error) {
        // error
      }
    },
    async fetchUserProfile() {
      this.clearMessage();
      const { status, result } = await getUserProfile(this.user);

      if (status) {
        this.profileUser = result.data;
      }
    },
    async getCartData() {
      this.loading++;
      let cart = await getDataCarts(this.user);
      if (cart.status) {
        this.cartData = cart.result.data.carts;
        this.$store.commit('quantityAddToCart/updateDrawerState', this.cartData.length);
      }
      this.loading--;
    },
    getNameCategoryById() {
      this.breadcrumbs.push({ id: 1, name: 'ホーム', link: '/' });
      this.$t('categories').find(obj => {
        if (obj.id === parseInt(this.product.categoryId)) {
          this.breadcrumbs.push({
            id: obj.id,
            name: obj.name,
            link: String('/customer/search/' + obj.id + '?keyword=') + '&begin_price=' + 0 + '&end_price=' + 0
          });
          obj.sub_categories.find(o => {
            if (o.id === parseInt(this.product.subCategory)) {
              this.breadcrumbs.push({
                id: o.id,
                name: o.name,
                link: String('/customer/search/' + o.id + '?keyword=') + '&begin_price=' + 0 + '&end_price=' + 0
              });
            }
          });
        }
      });
    },
    async getProductDetailById() {
      this.loading++;
      this.breadcrumbs = [];
      const { result, status } = await getProductDetail(this.id);
      if (status === status_response.success) {
        this.cartAmount = 1;
        this.product = result.data;
        this.isProductSold =
          this.product.in_stock == null || this.product.in_stock === undefined || this.product.in_stock === 0;
        this.getShopDetailByPublicAddress();
        this.getNameCategoryById();
        this.checkRecommended();
        this.properties = getProductProperties(this.product);
        for (let i = 0; i < this.properties.length; i++) {
          if (this.properties[i].quantity > 0 && !this.currentProperty) {
            this.currentProperty = this.properties[i].id;
            break;
          }
        }
      } else {
        this.errorId = result.messageId;
        console.log(this.messageId);
      }
      this.loading--;
    },
    async getShopDetailByPublicAddress() {
      this.loading++;
      const { result, status } = await getShopInfo(this.product.owner);
      this.loading--;
      if (status === status_response.success) {
        this.shop = result.data;

        this.$set(
          this.shop,
          'numOfReview',
          parseInt(result.data.statistic.numOfBad) + parseInt(result.data.statistic.numOfGood)
        );
        this.$set(
          this.shop,
          'totalPointReview',
          parseInt(result.data.statistic.numOfBad) + parseInt(result.data.statistic.numOfGood) * 5
        );
        this.$set(this.shopReviews, 'oneStar', parseInt(result.data.statistic.numOfBad));
        this.$set(this.shopReviews, 'twoStar', 0);
        this.$set(this.shopReviews, 'threeStar', 0);
        this.$set(this.shopReviews, 'fourStar', 0);
        this.$set(this.shopReviews, 'fiveStar', parseInt(result.data.statistic.numOfGood));
      } else {
        console.log(status);
        console.log(result);
      }
    },
    async productInFavourite() {
      this.clearMessage();
      if (this.user) {
        this.loading++;
        const { result, status } = await AddOrRemoveToFavouriteList(this.product.owner, this.id);
        if (status === status_response.success) {
          this.is_rating = result.data;
        }
        this.updateMessage(status, result);
        this.loading--;
      } else {
        this.$router.push({
          name: 'login',
          params: {
            page_expectations: '/customer/product/detail/' + this.product.id
          }
        });
      }
    },
    async checkProductInFavouriteList() {
      this.loading++;
      if (this.user) {
        const { result, status } = await checkProductInFavouriteList(this.id);
        if (status === status_response.success) {
          this.is_rating = result.data;
        }
      }
      this.loading--;
    },
    async addProductToCart() {
      if (this.isProductSold) {
        return;
      }
      // let statusResponse = status_response;
      this.clearMessage();
      // this.getCartData();
      if (this.user) {
        this.loading++;
        try {
          // Refresh product quantity from sidechain to have the latest update
          this.product.properties = await getProductStockById(this.product.id);
          this.product.quantity = this.product.properties.stock_num;
        } catch (err) {
          console.log('Cannot fetch product properties from sidechain, using old data', err);
        }
        if (this.properties.length > 0 && !this.currentProperty && this.currentProperty !== 0) {
          // eslint-disable-next-line no-alert
          alert('User must choose the property first');
          this.loading--;
          return;
        }

        const callback = await addToCart(this.product, this.cartAmount, this.currentProperty);
        // this.$emit('showMessage', callback);
        if (callback.status === status_response.success) {
          this.getCartData();
          this.messageId = callback.result.messageId;
          this.$store.commit('messageId/updateMessageIdErrorState', null);
          this.$store.commit('messageId/updateMessageIdSuccesState', callback.result.messageId);
        } else {
          this.errorId = callback.result.messageId;
          this.$store.commit('messageId/updateMessageIdSuccesState', null);
          this.$store.commit('messageId/updateMessageIdErrorState', callback.result.messageId);
        }
        this.loading--;
      } else {
        this.$router.push({
          name: 'login',
          params: {
            page_expectations: '/customer/product/detail/' + this.product.id
          }
        });
      }
    },
    async changeProperty(index) {
      this.clearMessage();
      this.currentProperty = this.properties[index].id;
    },
    async getOverview() {
      if (this.user) {
        const { status, result } = await getOverview();
        if (status) {
          this.recommendUsed = result.data.numOfRecommend.currentUsed;
          this.recommendTotal = result.data.numOfRecommend.total;
        } else {
          this.setErrorMessage(result);
        }
      }
    },
    async checkRecommended() {
      if (this.user) {
        const { status, result } = await checkProductInRecommendList(this.product.id);
        if (status) {
          this.isRecommended = result.data;
        } else {
          this.setErrorMessage(result);
        }
      }
    },
    async confirmRecommend() {
      if (this.isRecommended) return;
      if (!this.profileUser) {
        this.$router.push({ name: 'login', params: { page_expectations: this.$route.path } });
        return;
      }

      this.isRecommendShowActive = true;
    },
    async addRecommend() {
      this.clearMessage();
      if (this.user) {
        this.loading++;

        const { status, result } = await addProductRecommend(this.product.id);

        this.loading--;

        if (status) {
          this.isRecommended = true;
          this.setSuccessMessage(result);
        } else {
          this.setErrorMessage(result);
        }

        this.isRecommendShowActive = false;
      } else {
        this.$router.push({
          name: 'login',
          params: {
            page_expectations: '/customer/product/detail/' + this.product.id
          }
        });
      }
    }
  }
};
</script>
